


















import { Component, Vue, Prop } from 'vue-property-decorator';
import SlideReferenceItemPrefix from './SlideReferenceItemPrefix.vue';

@Component({
  components: {
    prefix: SlideReferenceItemPrefix
  }
})
export default class SlideReferenceItem extends Vue {
  [x: string]: any;
  @Prop({ type: String }) text!: string;
  @Prop({ type: String }) prefix!: string;
  @Prop({ type: Number }) index: number | undefined;
}
